import React from "react";
import { FaPencilAlt } from "react-icons/fa";
import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineDelete } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";

const FinanceFundCard = ({ fund, onEdit, onDelete, onView }) => {
  return (
    <div className="n-card shadow-lg w-full sm:w-50 h-auto overflow-hidden sm:h-100 m-4 rounded-lg p-2 border hover:shadow-xl cursor-pointer transition-all flex flex-col justify-between">
      <div>
        <div>
          <LazyLoadImage
            loading="lazy"
            src={fund?.image}
            alt="Product Image"
            className="w-full h-[130px] rounded-md object-fit transform transition-transform duration-300 cursor-pointer"
          />
        </div>
        <h2 className="text-lg font-bold text-ellipsis line-clamp-1">
          {fund.name}
        </h2>
        <span className="px-2 shadow border rounded-md">
          {fund.financeType}
        </span>

        {/* Render HTML content safely */}
        <p
          className="mt-1 mb-1 text-ellipsis line-clamp-1"
          dangerouslySetInnerHTML={{ __html: fund.overview }}
        ></p>

        <div className="flex justify-between text-sm mb-1">
          <span>
            <strong>Interest Rate:</strong> {fund.interestRate}%
          </span>
          <span>
            <strong>Loan Amount:</strong> {fund.loanAmount}
          </span>
        </div>
        <div>
          <span>
            <strong>Repayment Period:</strong> {fund.repaymentPeriod}
          </span>
          <span
            className="text-ellipsis line-clamp-1"
            dangerouslySetInnerHTML={{ __html: fund.eligibilityCriteria }}
          ></span>
        </div>

        <p
          className="text-sm mb-1 text-ellipsis line-clamp-1"
          dangerouslySetInnerHTML={{ __html: fund.applicationProcess }}
        ></p>
        <p className="text-sm mb-1">
          <strong>Contact:</strong> {fund.contactInfo}
        </p>

        <div className="flex justify-between items-center">
          <a
            href={fund.moreInfoLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline text-sm"
          >
            Learn more
          </a>
          <div className="flex justify-end items-center mt-1">
            <IoEyeOutline
              className="m-1 text-[1.5rem] hover:text-[2rem] hover:m-0 transition-all duration-200"
              onClick={() => onView(fund)}
            />
            <MdOutlineDelete
              className="m-1 text-[1.5rem] hover:text-[2rem] hover:m-0 transition-all duration-200"
              onClick={() => onDelete(fund._id)}
            />
            <FaPencilAlt
              onClick={() => onEdit(fund)}
              className="m-1 text-[1rem] hover:text-[1.5rem] hover:m-0 transition-all duration-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceFundCard;
